import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';

interface Props {
  open: boolean;
  /** The string the user must type to enable the destructive button. */
  confirmText: string;
  title: string;
  body?: string;
  destructiveLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  pending?: boolean;
}

/** Typed-name confirm dialog. Used for delete of rules/connections/provider configs. */
export function ConfirmTypedDelete({
  open,
  confirmText,
  title,
  body,
  destructiveLabel = 'Delete',
  onConfirm,
  onClose,
  pending,
}: Props) {
  const [value, setValue] = useState('');
  useEffect(() => {
    if (!open) setValue('');
  }, [open]);
  const matches = value === confirmText;
  return (
    <Dialog open={open} onClose={pending ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {body && <DialogContentText>{body}</DialogContentText>}
          <DialogContentText component="div">
            To confirm, type <strong>{confirmText}</strong> below.
          </DialogContentText>
          <TextField
            autoFocus
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            slotProps={{
              htmlInput: {
                'aria-label': `Type ${confirmText} to confirm`,
                autoCapitalize: 'off',
                autoCorrect: 'off',
                spellCheck: false,
              },
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={pending}>
          Cancel
        </Button>
        <Button color="error" disabled={!matches || pending} onClick={onConfirm}>
          {destructiveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
